// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"04564317","568":"6741aacc","994":"9eeff600"}[chunkId] + ".chunk.js";
};